export const GET_ALL_COLOR_REQUEST = "GET_ALL_COLOR_REQUEST";
export const GET_ALL_COLOR_FAILURE = "GET_ALL_COLOR_FAILURE";
export const GET_ALL_COLOR_SUCCESS = "GET_ALL_COLOR_SUCCESS";

export const CREATE_COLOR_REQUEST = "CREATE_COLOR_REQUEST";
export const CREATE_COLOR_FAILURE = "CREATE_COLOR_FAILURE";
export const CREATE_COLOR_SUCCESS = "CREATE_COLOR_SUCCESS";

export const UPDATE_COLOR_REQUEST = "UPDATE_COLOR_REQUEST";
export const UPDATE_COLOR_FAILURE = "UPDATE_COLOR_FAILURE";
export const UPDATE_COLOR_SUCCESS = "UPDATE_COLOR_SUCCESS";

export const DELETE_COLOR_REQUEST = "DELETE_COLOR_REQUEST";
export const DELETE_COLOR_FAILURE = "DELETE_COLOR_FAILURE";
export const DELETE_COLOR_SUCCESS = "DELETE_COLOR_SUCCESS";